/**
 * Created by jomsm on 13/07/2017.
 */
angular.module('Directives').directive('bbaCheckbox',

    function () {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/bbaCheckbox.html',
            replace: true,
            scope: {
                name: '@',
                ngModel: '=?',
                ngDisabled: '=?',
                label: '=',
                class: '@',
                onChange: '&',
                onClick: '&?',
                ngRequired: '=?'
            },
            link: bbaCheckboxLink
        }

        function bbaCheckboxLink($scope, $element, $attrs) {
            $scope.testAffix = $attrs.name;
        };
    }
);


// WEBPACK FOOTER //
// ./js/directives/bbaCheckbox.js